module.exports = __webpack_public_path__ + "media/images/common/close-9e0b0eb83e062115ba6327a40ba8eca4.png";